import {
  CALCULATIONS_CALL_API_SUCCESS,
  CALCULATIONS_CALL_API_FAILURE,
  CALCULATIONS_SET_PARAMETER_VALUE,
  CALCULATIONS_SWITCH_POROUS_STORAGE,
  CALCULATIONS_SWITCH_UNDERDRAIN,
  APPTOOLBAR_RESET_APP_STATE,
  APPTOOLBAR_SELECT_CHAMBER_TYPE,
  APPTOOLBAR_SET_CONSTRAINTS,
  SYSTEM_START_GENERATION,
  SYSTEM_END_GENERATION,
  VOLUME_START_OPTIMIZER,
  PROJECTS_CRUD_RESTORE_STATE,
  VOLUME_END_OPTIMIZER,
  CALCULATIONS_SET_MANIFOLD_SEPARATIONS,
  CONSTRAINTS_SET_DEFAULTS,
  CONSTRAINTS_SET_MAXIMUMS,
  CONSTRAINTS_SET_MINIMUMS,
  SHOW_GENERATE_ALERT,
  APPTOOLBAR_RESET_MULTIBED_STATE,
  SUB_PROJECTS_CRUD_RESTORE_STATE,
  APPTOOLBAR_BASIC_RESET_APP_STATE
} from "../lib/types";

const TAB_KEYS = {
  PARAMETERS: "PARAMETERS",
  CALCULATED: "CALCULATED"
};

const initialState = {
  /* UI properties */
  selectedTabKey: TAB_KEYS.CALCULATED,
  /* initial parameters */
  storageVolume: 500.0,
  porousStoneAbove: 12,
  porousStoneBelow: 9,
  porosityPercent: 40,
  //underdrain: true,
  underdrain: false,
  /* calculated values */
  requiredChambers: 0,
  requiredEndCaps: 0,
  numberOfRows: 0,
  systemLength: 0,
  systemWidth: 0,
  rectangularFootprint: 0,
  chamberStorage: 0,
  systemHeight: 0,
  totalStorageProvided: 0,
  amountOfStone: 0,
  porousStoneStorage: 0,
  percentageOfStorageProvided: 0,
  startUnits: 0,
  middleUnits: 0,
  endUnits: 0,
  scourProtectionFitting: 0,
  totalExcavation: 0,
  approximateTruckloads: 0,
  perimeter: 0,
  linerSqInchOverage: 0,
  geotextileQuantity: 0,
  geotextileQuantities: {
    nonWovenExcludingIsolator: 0,
    nonWovenIsolator: 0,
    nonWovenTotal: 0,
    wovenExcludingIsolator: 0,
    wovenIsolator: 0,
    totalWoven: 0,
    linerSqInchOverage: 0
  },
  manifoldSeparation: {
    round: 0,
    square: 0,
    nyloplast: 0
  },
  availableLength: 20,
  availableWidth: 20,
  hasOutlet: true,
  generateSystem: false,
  optimizeVolume: false,
  baseStoneElevation: 0,
  minimums: {},
  maximums: {},
  showGenerateAlert: false,
  hasImperviousLiner: false,
};

function roundNumber( num ) {
  return Math.round(num * 100) / 100;
}

export default ( state = initialState, action ) => {
  switch (action.type) {
    case APPTOOLBAR_SET_CONSTRAINTS:
      return {
        ...state,
        ...action.payload.defaults
      };

    case APPTOOLBAR_SELECT_CHAMBER_TYPE:
      // if base stone minimun is not the default, set the default as initial value
      // NOTE: this was done because ADS wanted the SC-160LP chamber type to have a default value
      // of 6 inches instead of the minimun 4 inches. Other chambers default is the minimun.
      let defaultBaseStone;
      if (
        action.payload.chamberType.baseStoneHeight !==
        action.payload.chamberType.baseStoneDefault
      ) {
        defaultBaseStone = action.payload.chamberType.baseStoneDefault;
      } else {
        defaultBaseStone = action.payload.chamberType.baseStoneHeight;
      }
      /* set state */
      return {
        ...state,
        porousStoneAbove: Math.round(
          action.payload.chamberType.coverStoneHeight * 12
        ),
        porousStoneBelow: Math.round(defaultBaseStone * 12),
        selectedTabKey: TAB_KEYS.PARAMETERS
      };

    case CONSTRAINTS_SET_DEFAULTS:
      const {
        availableLength,
        availableWidth,
        storageVolume,
        porousStoneAbove,
        porousStoneBelow,
        baseStoneElevation,
        porosityPercent,
        averageCover
      } = action.payload;

      return {
        ...state,
        availableLength,
        availableWidth,
        storageVolume,
        porousStoneAbove,
        porousStoneBelow,
        baseStoneElevation,
        porosityPercent,
        averageCover
      };

    case CONSTRAINTS_SET_MINIMUMS:
      return {
        ...state,
        minimums: action.payload
      };

    case CONSTRAINTS_SET_MAXIMUMS:
      return {
        ...state,
        maximums: action.payload
      };

    case CALCULATIONS_SET_MANIFOLD_SEPARATIONS:
      return {
        ...state,
        manifoldSeparations: action.payload.manifoldSeparations
      };

    case CALCULATIONS_CALL_API_SUCCESS:
      /* the API computed volume and calculations */
      let calculations = action.payload.calculations;

      let percentageStorageProvided = roundNumber(
        ( calculations.installedStorageVolume / state.storageVolume ) * 100
      );

      let manifoldSizing = action.payload.manifoldSizing;

      if (manifoldSizing === null) {
        manifoldSizing = {};
      }

      // TODO: Check this well, does not seems right
      /* new state */
      const result = {
        ...state,
        totalStorageProvided: calculations.installedStorageVolume,
        selectedTabKey: TAB_KEYS.CALCULATED,
        chamberStorage: calculations.totalChamberStorage,
        approximateTruckloads: calculations.approximateTruckloads,
        porousStoneStorage: calculations.stoneVolumeCalculated,
        amountOfStone: calculations.stoneAmountCalculated,
        percentageOfStorageProvided: percentageStorageProvided,
        /* set additional info */
        numberOfRows: calculations.numRows,
        requiredChambers: calculations.numChambers,
        requiredEndCaps: calculations.numEndCaps,
        systemLength: calculations.systemLength,
        systemWidth: calculations.systemWidth,
        rectangularFootprint: calculations.area,
        systemHeight: calculations.systemHeight,
        headerStorage: calculations.headerStorage,
        /* what are these fixed values ? */
        startUnits: 12,
        middleUnits: 79,
        endUnits: 12,
        scourProtectionFitting: calculations.amountOfScourMaterial,
        totalExcavation: calculations.totalExcavation,
        perimeter: calculations.perimeter,
        linerSqInchOverage: calculations.linerSqInchOverage,
        geotextileQuantity: calculations.geoTextileQuantity,
        geotextileQuantities: { ...calculations.geotextileQuantities },
        ...manifoldSizing
      };
      // console.log("CalculationResult:", result);
      return result;

    case CALCULATIONS_CALL_API_FAILURE:
      return {
        ...state,
        selectedTabKey: TAB_KEYS.PARAMETERS
      };

    case CALCULATIONS_SET_PARAMETER_VALUE:
      return {
        ...state,
        [action.payload.param]: action.payload.value,
        selectedTabKey: TAB_KEYS.PARAMETERS
      };

    case CALCULATIONS_SWITCH_POROUS_STORAGE:
      return {
        ...state,
        porousStorageBetweenChambers: !state.porousStorageBetweenChambers,
        selectedTabKey: TAB_KEYS.PARAMETERS
      };

    case CALCULATIONS_SWITCH_UNDERDRAIN:
      return {
        ...state,
        // underdrain: !state.underdrain,
        underdrain: false,
        selectedTabKey: TAB_KEYS.PARAMETERS
      };

    case SYSTEM_START_GENERATION:
      return {
        ...state,
        generateSystem: true
      };

    case SYSTEM_END_GENERATION:
      return {
        ...state,
        generateSystem: false
      };

    case VOLUME_START_OPTIMIZER:
      return {
        ...state,
        optimizeVolume: true
      };

    case VOLUME_END_OPTIMIZER:
      return {
        ...state,
        optimizeVolume: false
      };

    case APPTOOLBAR_BASIC_RESET_APP_STATE:
    case APPTOOLBAR_RESET_APP_STATE:
      return initialState;

    case APPTOOLBAR_RESET_MULTIBED_STATE:
      let averageCoverValue;
      try {
        averageCoverValue = action.payload.chamberType.webConstraints.averageCover.default;
      } catch (err) {
        averageCoverValue = 24;
      }
      const newInit = {
        /* initial parameters */
        storageVolume: 500.0,
        porousStoneAbove: 12,
        porousStoneBelow: 9,
        porosityPercent: 40,
        //underdrain: true,
        underdrain: false,

        /* calculated values */
        requiredChambers: 0,
        requiredEndCaps: 0,
        numberOfRows: 0,
        systemLength: 0,
        systemWidth: 0,
        rectangularFootprint: 0,
        chamberStorage: 0,
        systemHeight: 0,
        totalStorageProvided: 0,
        amountOfStone: 0,
        porousStoneStorage: 0,
        percentageOfStorageProvided: 0,
        startUnits: 0,
        middleUnits: 0,
        endUnits: 0,
        scourProtectionFitting: 0,
        totalExcavation: 0,
        approximateTruckloads: 0,
        perimeter: 0,
        linerSqInchOverage: 0,
        geotextileQuantity: 0,
        manifoldSeparation: {
          round: 0,
          square: 0,
          nyloplast: 0
        },
        availableLength: 20,
        availableWidth: 20,
        hasOutlet: true,
        generateSystem: false,
        optimizeVolume: false,
        baseStoneElevation: 0,
        // minimums: {},
        // maximums: {},
        showGenerateAlert: false,
        averageCover: averageCoverValue
      };

      return { ...state, ...newInit };

    case SUB_PROJECTS_CRUD_RESTORE_STATE:
    case PROJECTS_CRUD_RESTORE_STATE:
      let rState = action.payload.calculations;
      rState = {
        ...rState,
        manifoldSeparations: state.manifoldSeparations,
        minimums: state.minimums,
        maximums: state.maximums
      };
      return {
        ...rState
      };

    case SHOW_GENERATE_ALERT:
      return {
        ...state,
        showGenerateAlert: action.payload
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/calculations-reducer.js